import { render, staticRenderFns } from "./afasContactCreate.vue?vue&type=template&id=4ed48df0&"
import script from "./afasContactCreate.vue?vue&type=script&lang=js&"
export * from "./afasContactCreate.vue?vue&type=script&lang=js&"
import style0 from "./afasContactCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports